/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCalendarClock = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19 15a4 4 0 1 1 0 8 4 4 0 0 1 0-8zM9 2v2h6V2h2v2h5v10h-2V6h-3v2h-2V6H9v2H7V6H4v14h9v2H2V4h5V2zm10.75 15h-1.5v2.31l1.876 1.964 1.061-1.06-1.437-1.525zM7 15v2H5v-2zm3 0v2H8v-2zm3 0v2h-2v-2zm-6-3v2H5v-2zm3 0v2H8v-2zm3 0v2h-2v-2zm3 0v2h-2v-2zm3 0v2h-2v-2zM7 9v2H5V9zm3 0v2H8V9zm3 0v2h-2V9zm3 0v2h-2V9zm3 0v2h-2V9z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCalendarClock as CalendarClock };
